<template>
    <div class="delivery">
        <div class="delivery-title">
            <img src="https://cdn.magicmart.vip/website/assets/delivery.png" alt="供应链">
        </div>
        <div class="delivery-content">
            <div class="delivery-item">
                <div class="delivery-item-pic">
                    <img src="https://cdn.magicmart.vip/website/assets/deliveryPic1.png" alt="" />
                </div>
                <div class="delivery-item-content m-left-50">
                    <div class="delivery-item-title">顺丰战略合作 极速送达 安心无忧</div>
                    <div class="delivery-item-desc">官方唯一指定物流合作伙伴，定制潮玩配送方案，兼顾零售端消费者与渠道端合作方需求</div>
                    <div class="delivery-icon-list">
                        <div class="delivery-icon-item">
                            <img src="https://cdn.magicmart.vip/website/assets/deliveryIcon1.png" alt="">
                            <div class="delivery-icon-desc">顺丰</div>
                        </div>
                        <div class="delivery-icon-item">
                            <img src="https://cdn.magicmart.vip/website/assets/deliveryIcon2.png" alt="">
                            <div class="delivery-icon-desc">极速</div>
                        </div>
                        <div class="delivery-icon-item">
                            <img src="https://cdn.magicmart.vip/website/assets/deliveryIcon3.png" alt="">
                            <div class="delivery-icon-desc">运输</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="delivery-item m-top-50">
                <div class="delivery-item-content m-right-50 flex-end">
                    <div class="delivery-item-title">自营仓储  数字化管理  货品无忧</div>
                    <div class="delivery-item-desc text-right">全国多仓布局，全流程数字化管控，适配潮玩产品专业存储需求，保障货品完好与供货稳定</div>
                    <div class="delivery-icon-list">
                        <div class="delivery-icon-item">
                            <img src="https://cdn.magicmart.vip/website/assets/deliveryIcon1.png" alt="">
                            <div class="delivery-icon-desc">仓储</div>
                        </div>
                        <div class="delivery-icon-item">
                            <img src="https://cdn.magicmart.vip/website/assets/deliveryIcon2.png" alt="">
                            <div class="delivery-icon-desc">数字化</div>
                        </div>
                        <div class="delivery-icon-item">
                            <img src="https://cdn.magicmart.vip/website/assets/deliveryIcon3.png" alt="">
                            <div class="delivery-icon-desc">安心</div>
                        </div>
                    </div>
                </div>
                <div class="delivery-item-pic">
                    <img src="https://cdn.magicmart.vip/website/assets/deliveryPic2.png" alt="" />
                </div>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: 'DeliveryPage',
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped>
.delivery {
    width: 100%;
    background: #fff;
    padding-top: 145px;
    margin-bottom: 30px;
}

.delivery-title {
    width: 288px;
    height: 94px;
    margin: 0 auto;
    margin-bottom: 77px;
}

.delivery-title img {
    width: 100%;
    height: 100%;
}

.delivery-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.delivery-item {
    display: flex;
    align-items: center;
}

.delivery-item-pic {
    width: 691px;
    height: 338px;
}

.delivery-item-pic img {
    width: 100%;
    height: 100%;
}

.delivery-item-content {
    display: flex;
    flex-direction: column;
    
}

.delivery-item-title {
    font-weight: 800;
    font-size: 41px;
    color: #1B1B1B;
}

.delivery-item-desc {
    font-weight: 600;
    font-size: 19px;
    color: #727272;
    margin-top: 20px;
    max-width: 500px;
}

.delivery-icon-list {
    display: flex;
    margin-top: 58px;
}

.delivery-icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 43px;
}

.delivery-icon-item:last-child {
    margin-right: 0;
}

.delivery-icon-item img {
    width: 36px;
    height: 37px;
}

.delivery-icon-desc {
    font-weight: 600;
    font-size: 18px;
    color: #3A3A3A;
    margin-top: 5px;
}
.m-top-50 {
    margin-top: 50px;
}
.m-left-50 {
    margin-left: 50px;
}
.m-right-50 {
    margin-right: 50px;
}
.text-right { 
    text-align: right;
}
.flex-end { 
    align-items: flex-end;
}
</style>
